import { Suspense, useEffect, useRef, useState } from "react";
import "./style.css";
import ReactDOM from "react-dom/client";

import Scene1 from "./Scene1";
import Scene2 from "./Scene2";
import { Provider } from "react-redux";
import store from "../redux/store";
import CookiePopup from "./CookiePopup";
function App() {
  const [goToMount, setGoToMount] = useState(false);
  const [goToEarth, setGoToEarth] = useState(true);

  return (
    <div className="indexCont">
      <Provider store={store}>
      <CookiePopup/>
        <div
          id="body"
          style={{
            width: "100vw",
            height: "100vh",
            position: "fixed",
            top: "0",
            zIndex: "30",
            display: "none",
            transition: "all linear 1s",
          }}
        ></div>

        {/* {goToEarth && (
        <button
          className="sceneBtn sceneBtn1"
          style={{ zIndex: "200", position: "absolute", left: "0", top: "0",color:"white" }}
          onClick={() => {
            setGoToMount(true);
            setGoToEarth(false);
            document.getElementById("body").className = "transition";
            document.getElementById("body").style.display = "block";
            setTimeout(() => {
              document.getElementById("scene1").style.display = "none";
              document.getElementById("scene2").style.display = "block";
            }, 2000);
            setTimeout(() => {
              // setGoToMount(false)
              document.getElementById("body").style.display = "none";
            }, 4000);
          }}
        >
          Go to mount
        </button>
      )} */}

        {goToEarth && (
         <div className="birdBtnCont">
           <button
            onClick={() => {
              setGoToMount(true);
              setGoToEarth(false);
              document.getElementById("body").className = "transition";
              document.getElementById("body").style.display = "block";
              setTimeout(() => {
                document.getElementById("scene1").style.display = "none";
                document.getElementById("scene2").style.display = "block";
              }, 2000);
              setTimeout(() => {
                // setGoToMount(false)
                document.getElementById("body").style.display = "none";
              }, 4000);
            }}
            id="birdBtn"
          >
            <span class="button_top">Go to mount</span>
          </button>
         </div>
        )}

        {/* {goToMount && (
        <button
          className="sceneBtn sceneBtn2"
          style={{
            zIndex: "200",
            position: "absolute",
            left: "10vw",
            top: "0",
          }}
          onClick={() => {
            setGoToEarth(true);
            setGoToMount(false);
            document.getElementById("body").className = "transition";
            document.getElementById("body").style.display = "block";
            setTimeout(() => {
              document.getElementById("scene1").style.display = "block";
              document.getElementById("scene2").style.display = "none";
            }, 2000);
            setTimeout(() => {
              // setGoToMount(false)
              document.getElementById("body").style.display = "none";
            }, 4000);
          }}
        >
          Go to earth
        </button>
      )} */}

        <div id="scene1">
          <Scene1 goToEarth={goToEarth} goToMount={goToMount} />
        </div>

        <div id="scene2" style={{ display: "none" }}>
          <div id="blur"></div>
          <Scene2 goToEarth={goToEarth} goToMount={goToMount} />
        </div>
      </Provider>
    </div>
  );
}

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(<App />);
